<script>
import { authComputed } from "@/state/helpers";
import { required, requiredIf } from "vuelidate/lib/validators";
import errorHandler from "@/helpers/errorHandler";
import { hk_status, occupancy_status } from "@/helpers/global.variable";
import roomService from "@/helpers/APIService/room.service";

export default {
  data() {
    return {
      room: {
        room_type: null,
        building: null,
        room_number: null,
        floor: 0,
        room_range: null,
        connect_room_number: null,
        edit: false,
        id: null,
        hk_status: null,
        occupancy_status: null,
        occupancy_reason: null,
        title: "Add New Room",
        is_accessible: false,
        is_pet_friendly: false,
        is_smoking: false,
      },
      hk_status,
      occupancy_status,
      floorOptions: [],
      submitted: false,
      isBtnLoading: false,
      isRoomSingle: true,
      isSaveAndAddNew: false,
      isOccupancyReasonShow: false,
      isAddAndCountinueAdd: false,
    };
  },
  props: {
    currentProps: Object,
  },
  emits: ["submitted", "saveAndAddNew"],
  computed: {
    ...authComputed,
  },
  mounted() {
    this.editRoom();
  },
  methods: {
    editRoom() {
      if (this.currentProps.roomEdit) {
        this.buildingChange(this.currentProps.selectedRoom.building.id);
        this.room.building = this.currentProps.selectedRoom.building.id;
        this.room.room_number = this.currentProps.selectedRoom.room_number;
        this.room.floor = this.currentProps.selectedRoom.floor.id;
        this.room.room_type = this.currentProps.selectedRoom.room_type.id;
        this.room.room_range = this.currentProps.selectedRoom.room_range;
        this.room.connect_room_number =
          this.currentProps.selectedRoom.connect_room_number;
        this.room.title = "Update Room";
        this.room.edit = this.currentProps.roomEdit;
        this.room.id = this.currentProps.selectedRoom.id;
        this.room.is_accessible = this.currentProps.selectedRoom.is_accessible;
        this.room.is_pet_friendly =
          this.currentProps.selectedRoom.is_pet_friendly;
        this.room.is_smoking = this.currentProps.selectedRoom.is_smoking;
        this.isRoomSingle = true;
        this.room.hk_status = this.currentProps.selectedRoom.hk_status;
        this.room.occupancy_status =
          this.currentProps.selectedRoom.occupancy_status;
        this.room.occupancy_reason =
          this.currentProps.selectedRoom.occupancy_reason;
        if (
          this.currentProps.selectedRoom.occupancy_status == "ooo" ||
          this.currentProps.selectedRoom.occupancy_status == "oos"
        ) {
          this.isOccupancyReasonShow = true;
        }
      }
    },
    onSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        let roomData = new FormData();
        roomData.append("hotel", this.hotel.id);
        roomData.append("room_type", this.room.room_type);
        roomData.append("building", this.room.building);
        roomData.append("room_number", this.room.room_number);
        roomData.append("floor", this.room.floor);
        if (this.room.connect_room_number != null) {
          roomData.append("connect_room_number", this.room.connect_room_number);
        }
        roomData.append("is_accessible", this.room.is_accessible);
        roomData.append("is_pet_friendly", this.room.is_pet_friendly);
        roomData.append("is_smoking", this.room.is_smoking);
        roomData.append("hk_status", this.room.hk_status);
        roomData.append("occupancy_status", this.room.occupancy_status);
        if (this.room.occupancy_reason != null) {
          roomData.append("occupancy_reason", this.room.occupancy_reason);
        }

        if (!this.isRoomSingle) {
          roomData.append("room_range", this.room.room_range);
        }
        if (this.currentProps.roomEdit) {
          roomService
            .editRoom(roomData, this.room.id)
            .then((room) => {
              this.isBtnLoading = false;
              this.submitted = false;
              this.$emit("submitted", room, this.currentProps.roomEdit);
            })
            .catch((error) => {
              this.isBtnLoading = false;
              errorHandler(error);
            });
        } else {
          roomService
            .createRoom(roomData)
            .then((room) => {
              this.isBtnLoading = false;
              this.submitted = false;
              if (this.isAddAndCountinueAdd) {
                this.$emit("saveAndAddNew", room, this.currentProps.roomEdit);
                this.room = {
                  room_type: null,
                  building: null,
                  room_number: null,
                  floor: 0,
                  room_range: null,
                  connect_room_number: null,
                  edit: false,
                  id: null,
                  hk_status: null,
                  occupancy_status: null,
                  occupancy_reason: null,
                  title: "Add New Room",
                  is_accessible: false,
                  is_pet_friendly: false,
                  is_smoking: false,
                };
              } else {
                this.$emit("submitted", room, this.currentProps.roomEdit);
              }
            })
            .catch((error) => {
              console.log(error);
              this.isBtnLoading = false;
              errorHandler(error);
            });
        }
      }
    },
    // Method is use for save and add new guest continue
    saveAndAddNew() {
      this.isSaveAndAddNew = true;
      this.isAddAndCountinueAdd = true;
      this.onSubmit();
    },
    // Method is use for cancel to add new guest
    cancelSubmit() {
      this.$emit("cancelSubmit");
      this.isSaveAndAddNew = false;
    },
    // Method is use maintained floor options
    buildingChange(building_id) {
      const query = "?building=" + building_id ?? this.room.building;
      roomService
        .getFloorListByBuilding(query)
        .then((response) => {
          response.map((item) => {
            this.floorOptions.push({
              value: item.id,
              text: item.short_name + "-" + item.name,
            });
          });
        })
        .catch((error) => {
          this.isBtnLoading = false;
          errorHandler(error);
        });
    },
    // Method is used to manage occupancy status
    onOccupancyStatusChange() {
      this.room.occupancy_status == "ooo" || this.room.occupancy_status == "oos"
        ? (this.isOccupancyReasonShow = true)
        : (this.isOccupancyReasonShow = false);
    },
  },
  validations: {
    room: {
      room_type: {
        required,
      },
      building: {
        required,
      },
      room_number: {
        required,
      },
      floor: {
        required,
      },
      room_range: {
        required: requiredIf(function () {
          if (!this.isRoomSingle) {
            return true;
          }
        }),
      },
      occupancy_status: {
        required,
      },
      hk_status: {
        required,
      },
      occupancy_reason: {
        required: requiredIf(function () {
          if (this.isOccupancyReasonShow) {
            return true;
          }
        }),
      },
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <b-card-title>
          <h4 class="card-title">{{ room.title }}</h4>
        </b-card-title>
        <hr />
      </div>
      <div class="btn-group mb-3 btn-group-sm" role="group" v-if="!room.edit">
        <input
          type="radio"
          class="btn-check btn-sm"
          name="vbtn-radio"
          id="vbtn-radio1"
          autocomplete="off"
          checked
          @click="isRoomSingle = true"
        />
        <label class="btn btn-outline-primary mb-0" for="vbtn-radio1"
          >Single Room <span class="text-primary">*</span></label
        >
        <input
          type="radio"
          class="btn-check"
          name="vbtn-radio"
          id="vbtn-radio2"
          autocomplete="off"
          @click="isRoomSingle = false"
        />
        <label class="btn btn-outline-primary mb-0" for="vbtn-radio2"
          >Multi Room</label
        >
      </div>

      <div class="col-md-4">
        <b-form-group class="mb-3" label="Room Number" label-for="room_number">
          <template slot="label">
            Room Number <span class="text-danger">*</span>
          </template>
          <b-form-input
            id="room_number"
            autocomplete="off"
            :type="!isRoomSingle ? 'number' : 'text'"
            :placeholder="!isRoomSingle ? 'Room Number' : 'Room Number / Name'"
            v-model="room.room_number"
            name="number"
            :class="{
              'is-invalid': submitted && $v.room.room_number.$error,
            }"
            min="1"
          ></b-form-input>
          <div
            v-if="submitted && $v.room.room_number.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.room.room_number.required"
              >Room Number is required.</span
            >
          </div>
        </b-form-group>
      </div>
      <div class="col-md-4">
        <b-form-group
          class="mb-3 form-label"
          label="Room building"
          label-for="building"
        >
          <template slot="label">
            Room building <span class="text-danger">*</span>
          </template>
          <b-form-select
            class="form-select"
            id="building"
            type="text"
            autocomplete="off"
            v-model="room.building"
            :options="currentProps.building"
            :class="{
              'is-invalid': submitted && $v.room.building.$error,
            }"
            @change="buildingChange"
          >
          </b-form-select>
          <div
            v-if="submitted && $v.room.building.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.room.building.required"
              >Room building is required.</span
            >
          </div>
        </b-form-group>
      </div>
      <div class="col-md-4">
        <b-form-group class="mb-3 form-label" label="Floor" label-for="floor">
          <span slot="label">Floor <span class="text-danger">*</span></span>
          <b-form-select
            class="form-select"
            id="floor"
            type="text"
            autocomplete="off"
            v-model="room.floor"
            :options="floorOptions"
            :class="{
              'is-invalid': submitted && $v.room.floor.$error,
            }"
          >
          </b-form-select>
          <div
            v-if="submitted && $v.room.floor.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.room.floor.required">Floor is required.</span>
          </div>
        </b-form-group>
      </div>
      <div class="col-md-4" v-if="!isRoomSingle">
        <b-form-group class="mb-3" label="Range" label-for="range">
          <template slot="label">
            Range <span class="text-danger">*</span>
            <i
              class="fa fa-info-circle text-muted ms-2"
              v-b-popover.hover="
                `we will create room from room no to range.  
                 Ex: Room No : 101 And in range 110. Creates 101 TO 110 Rooms`
              "
            ></i>
          </template>
          <b-form-input
            id="range"
            type="number"
            name="number"
            autocomplete="off"
            placeholder="Ex :we'll create room no to range"
            v-model="room.room_range"
            :class="{
              'is-invalid': submitted && $v.room.room_range.$error,
            }"
          ></b-form-input>
          <div
            v-if="submitted && $v.room.room_range.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.room.room_range.required"
              >Room range is required.</span
            >
          </div>
        </b-form-group>
      </div>
      <div class="col-md-4" v-if="isRoomSingle">
        <b-form-group
          class="mb-3 form-label"
          label="Room Type"
          label-for="room_type"
        >
          <template slot="label">
            Room Type <span class="text-danger">*</span>
          </template>
          <b-form-select
            class="form-select"
            id="room_type"
            type="text"
            autocomplete="off"
            v-model="room.room_type"
            :options="currentProps.roomType"
            :class="{
              'is-invalid': submitted && $v.room.room_type.$error,
            }"
          >
          </b-form-select>
          <div
            v-if="submitted && $v.room.room_type.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.room.room_type.required"
              >Room Type is required.</span
            >
          </div>
        </b-form-group>
      </div>
      <div class="col-md-4" v-if="!isRoomSingle">
        <b-form-group
          class="mb-3 form-label"
          label="Room Type"
          label-for="room_type"
        >
          <template slot="label">
            Room Type <span class="text-danger">*</span>
          </template>
          <b-form-select
            class="form-select"
            id="room_type"
            type="text"
            autocomplete="off"
            v-model="room.room_type"
            :options="currentProps.roomType"
            :class="{
              'is-invalid': submitted && $v.room.room_type.$error,
            }"
          >
          </b-form-select>
          <div
            v-if="submitted && $v.room.room_type.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.room.room_type.required"
              >Room Type is required.</span
            >
          </div>
        </b-form-group>
      </div>
      <div class="col-md-4">
        <b-form-group
          class="mb-3 form-label"
          label="House Keeping Status"
          label-for="hk_status"
        >
          <template slot="label">
            House Keeping Status<span class="text-danger">*</span>
          </template>
          <b-form-select
            class="form-select"
            id="hk_status"
            type="text"
            autocomplete="off"
            v-model="room.hk_status"
            :options="hk_status"
            :class="{
              'is-invalid': submitted && $v.room.hk_status.$error,
            }"
          >
            <div
              v-if="submitted && $v.room.hk_status.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.room.hk_status.required"
                >House Keeping Status is required.</span
              >
            </div>
          </b-form-select>
        </b-form-group>
      </div>
      <div class="col-md-4">
        <b-form-group
          class="mb-3 form-label"
          label="occupancy Status"
          label-for="occupancy_status"
        >
          <template slot="label">
            Occupancy Status <span class="text-danger">*</span>
          </template>
          <b-form-select
            class="form-select"
            id="occupancy_status"
            type="text"
            autocomplete="off"
            v-model="room.occupancy_status"
            :options="occupancy_status"
            @change="onOccupancyStatusChange()"
            :class="{
              'is-invalid': submitted && $v.room.occupancy_status.$error,
            }"
          >
            <div
              v-if="submitted && $v.room.occupancy_status.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.room.occupancy_status.required"
                >Occupancy Status is required.</span
              >
            </div>
          </b-form-select>
        </b-form-group>
      </div>
      <div class="col-md-4" v-if="isRoomSingle">
        <b-form-group
          class="mb-3"
          label="Connecting To"
          label-for="connect_room_number"
        >
          <b-form-input
            id="connect_room_number"
            type="number"
            autocomplete="off"
            placeholder="Room Number"
            v-model="room.connect_room_number"
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-4" v-if="isOccupancyReasonShow">
        <b-form-group
          class="mb-3 form-label"
          label="occupancy Reason"
          label-for="occupancy_Reason"
        >
          <template slot="label">
            Occupancy Reason <span class="text-danger">*</span>
          </template>
          <b-form-input
            class="form-input"
            id="occupancy_reason"
            type="text"
            autocomplete="off"
            v-model="room.occupancy_reason"
            :class="{
              'is-invalid': submitted && $v.room.occupancy_reason.$error,
            }"
          >
          </b-form-input>
          <div
            v-if="submitted && $v.room.occupancy_reason.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.room.occupancy_reason.required"
              >Occupancy Reason is required.</span
            >
          </div>
        </b-form-group>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <div class="form-check form-switch form-switch-md mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="is_accessible"
            checked
            v-model="room.is_accessible"
          />
          <label class="form-check-label" for="is_accessible">Accessible</label>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-check form-switch form-switch-md mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="is_pet_friendly"
            checked
            v-model="room.is_pet_friendly"
          />
          <label class="form-check-label" for="is_pet_friendly"
            >Pet Friendly</label
          >
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-check form-switch form-switch-md mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="is_smoking"
            checked
            v-model="room.is_smoking"
          />
          <label class="form-check-label" for="is_smoking">Smoking</label>
        </div>
      </div>
      <hr />
      <div class="col-md-12">
        <b-button
          class="float-end ms-2"
          variant="outline-primary"
          type="reset"
          @click="cancelSubmit"
          >Cancel</b-button
        >
        <b-button
          v-if="this.currentProps.roomEdit === false"
          class="float-end ms-2"
          variant="outline-primary"
          type="submit"
          @click="saveAndAddNew"
          :class="{ disabled: isSaveAndAddNew === true && isBtnLoading }"
        >
          <i
            v-if="isSaveAndAddNew === true && isBtnLoading"
            class="bx bx-loader bx-spin font-size-16 align-middle me-2"
          ></i
          >Save & Add</b-button
        >
        <b-button
          class="float-end ms-2"
          variant="outline-primary"
          :class="{ disabled: isSaveAndAddNew === false && isBtnLoading }"
          @click="onSubmit"
        >
          <i
            v-if="isSaveAndAddNew === false && isBtnLoading"
            class="bx bx-loader bx-spin font-size-16 align-middle me-2"
          ></i
          >{{ this.currentProps.roomEdit ? "Update Room" : "Save" }}
        </b-button>
      </div>
    </div>
  </div>
</template>
